import {
  AlertOutlined,
  AppstoreOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  BellOutlined,
  BookOutlined,
  BranchesOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  ContactsOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  FileDoneOutlined,
  FileOutlined,
  FileTextOutlined,
  HistoryOutlined,
  IdcardOutlined,
  InboxOutlined,
  KeyOutlined,
  LoginOutlined,
  MailOutlined,
  NodeIndexOutlined,
  PieChartOutlined,
  ProfileOutlined,
  QrcodeOutlined,
  RetweetOutlined,
  SafetyOutlined,
  SendOutlined,
  SettingOutlined,
  StopOutlined,
  SyncOutlined,
  TeamOutlined,
  ToolOutlined,
  UploadOutlined,
  UserOutlined,
  UserSwitchOutlined,
  UsergroupAddOutlined,
} from '@/shared/ui/icons'
import {
  ActivityOutlined as Activity,
  RetweetOutlined as ArrowRightLeft,
  BarChartOutlined as BarChart3,
  BookOpenOutlined as BookOpen,
  BuildingOutlined as Building,
  BankOutlined as Building2,
  ClipboardListOutlined as ClipboardList,
  FactoryOutlined as Factory,
  FileBarChartOutlined as FileBarChart,
  FileCheckOutlined as FileCheck,
  FileSignatureOutlined as FileSignature,
  FileExcelOutlined as FileSpreadsheet,
  FolderOutlined as Folder,
  FolderTreeOutlined as FolderTree,
  HandshakeOutlined as Handshake,
  KeySquareOutlined as KeySquare,
  DashboardOutlined as LayoutDashboard,
  LineChartOutlined as LineChart,
  LinkOutlined as Link,
  ListTreeOutlined as ListTree,
  MapOutlined as MapIcon,
  EnvironmentOutlined as MapPin,
  MenuOutlined as Menu,
  PackageOutlined as Package,
  PackagePlusOutlined as PackagePlus,
  PieChartOutlined as PieChart,
  PlugOutlined as Plug,
  QrcodeOutlined as QrCode,
  ScaleOutlined as Scale,
  ScanLineOutlined as ScanLine,
  ScrollTextOutlined as ScrollText,
  SafetyOutlined as ShieldCheck,
  ShoppingCartOutlined as ShoppingCart,
  StarOutlined as Star,
  TagOutlined as Tag,
  TicketOutlined as Ticket,
  TicketPlusOutlined as TicketPlus,
  TrendingUpOutlined as TrendingUp,
  TeamOutlined as Users,
} from '@/shared/ui/icons'
import { type ComponentType, createElement } from 'react'

// khớp tên icon gán trong MenuConfig.ts (trường `icon` của từng nhóm/leaf).
// Một số tên menu cũ giữ nguyên để tương thích MenuConfig.ts; mọi component icon
// đều được ánh xạ qua adapter Lucide dùng chung.
// Kiểu ComponentType<any> giữ tương thích với createElement trong menu động.
// Map alias MapIcon để không shadow global Map (biome noShadowRestrictedNames)
const ICON_MAP: Record<string, ComponentType<any>> = {
  Activity,
  ArrowRightLeft,
  BarChart3,
  BookOpen,
  Building,
  Building2,
  ClipboardList,
  Factory,
  FileBarChart,
  FileCheck,
  FileSignature,
  FileSpreadsheet,
  FolderTree,
  Handshake,
  KeySquare,
  LayoutDashboard,
  LineChart,
  Link,
  ListTree,
  Map: MapIcon,
  MapPin,
  Menu,
  Package,
  PackagePlus,
  PieChart,
  Plug,
  QrCode,
  Scale,
  ScanLine,
  ScrollText,
  ShieldCheck,
  ShoppingCart,
  Star,
  Tag,
  Ticket,
  TicketPlus,
  TrendingUp,
  Users,
  // Tên icon cũ trong MenuConfig.ts, hiện dùng component Lucide tương ứng.
  AlertOutlined,
  AppstoreOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  BellOutlined,
  BranchesOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  ContactsOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  FileDoneOutlined,
  FileOutlined,
  FileTextOutlined,
  FolderOutlined: Folder,
  HistoryOutlined,
  IdcardOutlined,
  InboxOutlined,
  KeyOutlined,
  LoginOutlined,
  MailOutlined,
  NodeIndexOutlined,
  PieChartOutlined,
  ProfileOutlined,
  QrcodeOutlined,
  RetweetOutlined,
  SafetyOutlined,
  SendOutlined,
  SettingOutlined,
  StopOutlined,
  SyncOutlined,
  TeamOutlined,
  ToolOutlined,
  UploadOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  BookOutlined,
}

// size: 16 định cỡ icon lucide (SVG width/height). AntD icon không nhận prop size,
// nó ăn theo font-size kế thừa — thêm style.fontSize để về cùng 16px, tránh to bất
// thường so với icon lucide cũ khi hai loại icon trộn trong cùng ICON_MAP.
export const getMenuIcon = (name?: string) =>
  name && ICON_MAP[name]
    ? createElement(ICON_MAP[name], { size: 16, style: { fontSize: 16 } })
    : undefined
